import PropTypes from 'prop-types';
export const youtubePlayerPropTypes = {
  id: PropTypes.string,
  buttonLabel: PropTypes.string,
  alt: PropTypes.string
};